import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FeedbackHero from './components/FeedbackHero';
import FeedbackList from './components/FeedbackList';

const FeedbackPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Suspense fallback={<div>Loading...</div>}>
        <FeedbackHero />
        <FeedbackList />
      </Suspense>
      <Footer />
    </div>
  );
};

export default FeedbackPage;
